// extracted by mini-css-extract-plugin
module.exports = {"toggle-theme-wrapper":"DarkMode_toggle-theme-wrapper__y0Owh","toggle-theme":"DarkMode_toggle-theme__YglN_","slider":"DarkMode_slider___4xKK","round":"DarkMode_round__ACGJ1"};